import { useTranslations } from 'next-intl';

import styles from './InexactDaysButtons.module.css';

export function InexactDaysButtons({ onSelect, value, theme = '' }) {
  const t = useTranslations();
  return (
    <section
      className={`${styles.section} ${
        theme === 'mobile'
          ? '!flex-nowrap overflow-x-auto !px-4 !py-3 sm:!px-10 !m-0 border-t border-slate-300'
          : ''
      }`}
    >
      <button
        type="button"
        className={`btn btn-sm whitespace-nowrap ${
          0 === value ? '!btn-primary' : 'btn-second'
        }`}
        onClick={() => onSelect(0)}
      >
        {t('exact-days')}
      </button>
      {[
        { key: 'one-day', days: 1 },
        { key: 'two-days', days: 2 },
        { key: 'three-days', days: 3 },
        { key: 'seven-days', days: 7 },
      ].map(({ key, days }) => {
        return (
          <button
            type="button"
            onClick={() => onSelect(days)}
            className={`btn btn-sm whitespace-nowrap ${
              days === value ? '!btn-primary' : 'btn-second'
            }`}
            key={key}
          >
            <div className="flex h-full mr-2 -ml-1.5">
              <PlusMinusIcon />
            </div>
            {t(key)}
          </button>
        );
      })}
    </section>
  );
}

function PlusMinusIcon({ width = 24, height = 24 }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M17 10L7 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17 20L7 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 5L12 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
